import { DesignUpload } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSigned, postToApiSigned } from './fetchFromApi';

export const uploadImage = (file: FormData, signal?: AbortSignal) =>
  postToApiSigned<DesignUpload>(
    `${getParams().context}s/${getParams().contextId}/design-uploads`,
    file,
    {},
    signal
  );

export const fetchDesignUpload = (id: string, signal?: AbortSignal) =>
  fetchFromApiSigned<DesignUpload>(
    `${getParams().context}s/${getParams().contextId}/design-uploads/${id}`,
    undefined,
    { signal }
  );
